export default {
    name: "cpt-category-list",
    data() {
        return {
            isLoading: true,
            perPage: parseInt(this.postsPerPage),
            posts: this.json.posts,
            categories: this.json.cats,
            currentCat: null,
            currentPage: 1,

        }
    },

    props: {
        json: Object,
        postsPerPage: [Number, String],
    },

    watch: {
        currentCat(newVal, oldVal) {
            this.currentPage = 1;
        },
    },

    computed: {
        postsList() {
            let posts = this.posts;

            if (this.currentCat !== null) {
                posts = posts.filter(post => {
                    return post.categories.includes(this.currentCat);
                    // return post.categories.some(cat => this.currentCat.includes(cat));
                })
            }

            return posts;
        },

        printedPosts() {
            const start = this.currentPage * this.perPage - this.perPage,
                end = this.currentPage * this.perPage;

            return this.postsList.slice(start, end)
        },

        postsAmount() {
            return this.posts.length
        },

        pages() {
            return Math.round(this.postsList.length / this.perPage);
        }
    },

    methods: {
        loadMore() {
            this.lastItem = this.lastItem + this.step;
        },

        mapCategory(selectedCategory) {
            const catIndex = this.currentCat.indexOf(selectedCategory);
            if (catIndex > -1) {
                this.currentCat.splice(catIndex, 1);
            } else {
                this.currentCat.push(selectedCategory);
            }
        }
    },
}